// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f8b12864691021125bb7","655":"969090f22d7430d5b7bb"}[chunkId] + ".js";
};